module.exports = __webpack_public_path__ + "static/img/deve6.ee3bec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deve6.png
// module id = v673
// module chunks = 1